import { Component } from '@angular/core';
import { WebsiteSessionService } from './shared/services/http-services/website-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'فطن';

  constructor(private websiteSession: WebsiteSessionService) {
    this.websiteSession.init();
  }
}
